import { render, staticRenderFns } from "./HeaderAdvertisementDetail.vue?vue&type=template&id=21a8ef87&"
import script from "./HeaderAdvertisementDetail.vue?vue&type=script&lang=js&"
export * from "./HeaderAdvertisementDetail.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAdvertisementDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports